export enum DiscrepancyPermission {
    view_discrepancy = 0,
    view_discrepancy_documents = 1,
}

export enum ActivitySettingsPermission {
    view_activity_permissions = 0,
    update_activity_permissions = 1
}

export enum CategoryType {
    ReasonOfQuoteRejection = 23,
    DiscrepancyType = 14,
    DiscreapancyCloseReason = 24,
    DiscrepancyClassification = 25,
    DiscrepancySeverity = 26
}

export enum DeleteErrorResult {
    HasRelatedEntity = 0
}

export enum CreateErrorResult {
    AlreadyExists = 0,
    AlreadyExistsButBelongToADifferentCompany = 1,
    GuestUserInCompany = 2,
    HasLowerPermissionLevel = 3
}

export enum SubContext {
    Order = 0,
    Contact = 1,
    Document = 2,
    Description = 3,
    ServiceForm = 4,
    ServiceTask = 5,
    Note = 6,
    Quote = 7,
}

export enum ActionType {
    New = 0,
    Change = 1,
    Delete = 2,
    Lifecycle = 3
}

export enum ActionParameter {
    //Lifecycle related
    NotDraft = 0,
    PlannedStartDate = 1,
    PlannedFinishDate = 2,
    Started = 3,
    Finished = 4,
    Sent = 5,
    Accepted = 6,
    Rejected = 7,
    Planned = 8,
    Assigned = 9,
    // Changed related
    Category = 10,
    Discrepancy = 11,
    Priority = 12,
    ExtraOrderCategory1 = 13,
    ExtraOrderCategory2 = 14,
    Event = 15,
    Invoicing = 16,
}

export enum DiscrepancyStatus {
    New = 0,
    RequestAction = 1,
    RequestQuote = 2,
    Closed = 3,
    NextService = 4,
}

export type DiscrepancyListContextKeys = keyof typeof DiscrepancyListContext;


export enum DiscrepancyListContext {
    Main = 0,
    Quote = 1,
    Order = 2,
    Asset = 3,
    Customer = 4
}

export enum FilterType {
    order,
    site,
    serviceUnit
}

export enum DiscrepancyAction {
    RequestClose = 0,
    CancelClose = 1,
    RequestAction = 2,
    RequestQuote = 3,
    AssignToQuote = 4
}

export enum CreateOrderPermission {
    create_work_orders = 0,
    create_repair_orders = 1, //equipment
    create_free_orders = 2,
    create_customer_specified_date_orders = 3
}


export enum DateRequestPermission {
    date_request_can_set_date_only = 0,
    date_request_show_startby_and_endby_datepicker = 1,
    date_request_can_choose_saturday = 2,
    date_request_can_choose_sunday = 3,
    date_request_can_choose_holiday = 4
}

export enum CreateOrderRequiredFieldSetting {
    create_orders_required_input_customerreference = 0,
    create_orders_required_input_mainorder = 1,
    create_orders_required_input_requisition = 2
}

export enum CreateOrderVisibleFieldSetting {
    create_orders_visible_input_customerreference = 0,
    create_orders_visible_input_mainorder = 1,
    create_orders_visible_input_requisition = 2
}

export enum DiscrepancyActionType {
    RequestClose = 0,
    CancelClose = 1,
    RequestAction = 2,
    RequestQuote = 3,
    AssignToNextService = 4,
    Reset = 5
}

export enum DiscrepancyCommentType {
    Internal = 0,
    External = 1
}

export enum AuthMethod {
    AzureB2C = 'AzureB2C',
    IDM = 'IDM'
}

export enum EmailTemplateTypeModel {
    UserCreationTemplate = 0,
    UserBackendAssignmentAddedTemplate = 1,
    CustomerPortalInviteTemplate = 2,
    WebOfficeInviteTemplate = 3,
    ForgottenPasswordTemplate = 4,
    VerificationCode = 5
  }